<template>
  <div>
    <div class="text-center" v-show="menu === 1">
      <loading v-if="load"/>
      <div v-show="!load">
        <div class="mb-4">
          <label class="mb-0">Informe seu CEP</label>
          <div class="text-danger font-weight-bold small mb-2" v-if="cepError">Por favor, digite um CEP válido.</div>
        </div>
        <div class="mb-4">
          <the-mask id="cepForm" type="tel" :mask="['#####-###']" class="form-cep" placeholder="00000-000" v-model="queryCep" @input="buscarCep" :disabled="load"/>
        </div>
        <button class="btn btn-primary btn-block" @click="buscarCep()">
          <i class="fa fa-search"></i><span class="ml-2">Buscar CEP</span>
        </button>
        <div class="mt-4">
          <a href="javascript:" class="text-primary" @click="alterarToPlace(2)">Não sei meu CEP</a>
        </div>
      </div>
    </div>
    <div class="form-group text-center" v-show="menu === 2">
      <label for="logradouro" class="mb-3">Informe sua Rua</label>
      <div class="d-flex mb-3">
        <div class="form-search w-100 mr-1">
          <span class="input-icon"><i class="fa fa-search"></i></span>
          <input id="logradouro" type="search" class="form-control" placeholder="Ex: Av Oliveira Nicácio" v-model="queryPlace" @keyup.enter="buscarPlace()"/>
        </div>
        <div>
          <button class="btn btn-primary" @click="buscarPlace()" :disabled="load">
            Pesquisar
          </button>
        </div>
      </div>
      <div class="mt-4">
        <loading v-if="load"/>
        <div class="text-left" v-if="places.length">
          <div class="d-flex align-items-center pointer" v-for="(p, idx) in places" :key="idx" @click="selPlace(p)" style="padding: 8px 0">
            <div class="text-left" style="width: 40px">
              <icon name="address" size="24" class="text-muted"></icon>
            </div>
            <div>
              <div class="text-muted font-weight-bold">{{ p.logradouro }}</div>
              <div class="small">{{ p.bairro }}, {{p.localidade}} - {{p.uf}}</div>
            </div>
          </div>
          <div class="d-flex align-items-center pointer" @click="$emit('buscarMapa')" style="padding: 8px 0">
            <div class="text-left" style="width: 40px">
              <icon name="map" size="24" class="text-muted"></icon>
            </div>
            <div>
              <div class="text-primary font-weight-bold">Não achei meu endereço</div>
              <div class="small">Buscar pelo mapa</div>
            </div>
          </div>
        </div>
        <div style="margin: 28px 0" v-if="notFound">
          <icon name="address" size="24"></icon>
          <h6 class="my-2">Endereço não encontrado</h6>
          <a href="javascript:" class="text-primary" @click="$emit('buscarMapa')">Buscar pelo Mapa</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {TheMask} from 'vue-the-mask';
import Icon from "../../components/Icon";
import Loading from "../Loading";

export default {
  components: {Loading, Icon, TheMask },
  props: ['usarGeolocalizacao'],
  data() {
    return {
      queryCep: '',
      queryPlace: '',
      places: [],
      sessionToken: null,
      google: null,
      notFound: false,
      menu: 1,
      cepError: null,
      load: false,
      debounceTimer: null,
      sigla_estado: '',
      nome_cidade: '',
    };
  },

  methods: {
    alterarToPlace() {
      if (this.usarGeolocalizacao) {
        this.clear(2);
        this.$nextTick(() => {
          this.$helpers.focusrElement('logradouro');
        });

      } else {
        this.$emit('selPlace', {}, true);
      }
    },

    clear(menu) {
      this.menu = menu;
      this.queryCep = '';
      this.queryPlace = '';
      this.cepError = false;
    },

    async buscarCep() {
      if (this.queryCep.length !== 8 || this.load) return;

      await new Promise(r => setTimeout(r, 250));

      this.cepError = false;
      this.load = true;

      this.$http.get('https://viacep.com.br/ws/'+ this.queryCep +'/json')
        .then(response => {
          const dados = response.data;
          this.load = false;
          this.queryCep = '';

          if (dados.erro) {
            this.cepError = true;
            this.$swal('Por favor informe um CEP válido!').then(() => {
              this.$helpers.focusrElement('cepForm');
            });

            return;
          }

          this.selPlace(dados);
          this.load = false;

        }, res => {
          console.log(res);
          this.load = false;
        });
    },

    buscarPlace() {
      if (this.load) return;

      this.notFound = false;
      this.places = [];

      if (this.queryPlace.length < 4) {
        this.$swal('Informe pelo menos 4 letras para pesquisar').then(() => {
          this.$helpers.focusrElement('logradouro');
        });

        return;
      }

      this.load = true;
      this.$http.get(`https://viacep.com.br/ws/${this.sigla_estado}/${this.nome_cidade}/`+ this.queryPlace +'/json')
        .then(response => {
          const dados = response.data;
          this.load = false;

          if (dados.erro) {
            this.queryPlace = '';
            return;
          }

          this.places = dados;
          this.notFound = dados.length === 0;

        }, res => {
          console.log(res);
          this.load = false;
        });
    },

    async selPlace(end) {
      this.clear(1);

      if (end.ibge !== this.empresa.ibge && this.limitarCidade) {
        this.$swal('Entregas aceitas apenas para ' + this.empresa.nome_cidade + ' - ' + this.empresa.sigla_estado + '.\nLocalização informada: ' + end.localidade + ' - ' + end.uf).then(() => {
          this.$helpers.focusrElement(this.menu === 1 ? 'cepForm' : 'logradouro');
        });

        return;
      }

      this.$emit('selPlace', {
        logradouro: end.logradouro,
        numero: '',
        bairro: end.bairro,
        nome_cidade: end.localidade,
        sigla_estado: end.uf,
        cep: (end.cep || '').replace(/[^0-9]/g, ''),
        ibge: end.ibge
      });
    },
  },

  mounted() {
    this.sigla_estado = this.empresa.sigla_estado;
    this.nome_cidade = this.empresa.nome_cidade;
  },

  computed: {
    empresa() {
      return this.$store.state.empresa;
    },

    limitarCidade() {
      return parseInt(this.empresa.limitar_cidade) === 1;
    }
  }
};
</script>
<style scoped>
.form-cep {
  width: 100%;
  max-width: 280px;         /* tamanho máximo */
  font-size: 2rem;          /* fonte grande */
  letter-spacing: 3px;      /* espaçamento entre caracteres */
  text-align: center;       /* centraliza o texto */
  border: none;             /* remove bordas */
  background-color: transparent; /* sem fundo */
  outline: none;            /* remove highlight azul ao focar */
  padding: 8px 0;           /* espaço interno vertical */
  color: #333;              /* cor do texto */
  transition: border-color 0.3s ease;
  font-weight: 300;
}

.form-cep::placeholder {
  color: #ccc;              /* placeholder mais suave */
  letter-spacing: 1px;
}
</style>